import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { borderRadius, codeFontFamily, gridSize } from '@atlaskit/theme/constants';
import { CODE_FONT_SIZE, CODE_LINE_HEIGHT, VAR_CODE_FONT_FAMILY, VAR_CODE_FONT_FAMILY_ITALIC, VAR_CODE_LINE_NUMBER_BG_COLOR } from './constants';
import { defaultColors } from './defaultTheme';
export var getLineNumWidth = function getLineNumWidth(numLines) {
  if (!numLines) {
    return '1ch';
  }

  return "".concat(numLines.toFixed(0).length, "ch");
}; // applied to the main parent of the react-syntax-highlighter

var codeContainerStyle = function codeContainerStyle(hasLineNumbers) {
  return {
    padding: hasLineNumbers ? "".concat(gridSize(), "px 0") : gridSize()
  };
};

var lineNumberStyle = function lineNumberStyle(theme) {
  return {
    // need this for margins
    fontFamily: "var(".concat(VAR_CODE_FONT_FAMILY, ") !important"),
    // width of the line number gutter
    minWidth: "calc(".concat(theme.lineNumberWidth, " + ").concat(gridSize() * 2, "px)"),
    // this needs to be important or it gets overwritten by inline styles
    fontStyle: 'normal !important',
    // this needs to be important or it gets overwritten by inline styles
    color: "".concat(theme.lineNumberColor, " !important"),
    flexShrink: 0,
    // needed to replicate existing design spec
    boxSizing: 'border-box',
    paddingRight: gridSize(),
    paddingLeft: gridSize(),
    marginRight: gridSize(),
    textAlign: 'right',
    userSelect: 'none',
    // this is to fix SSR spacing issue
    display: 'block'
  };
};

var sharedCodeStyle = function sharedCodeStyle(theme) {
  return {
    key: {
      color: theme.keywordColor,
      fontWeight: 'bolder'
    },
    keyword: {
      color: theme.keywordColor,
      fontWeight: 'bolder'
    },
    'attr-name': {
      color: theme.attributeColor
    },
    selector: {
      color: theme.selectorTagColor
    },
    comment: {
      color: theme.commentColor,
      fontFamily: "var(".concat(VAR_CODE_FONT_FAMILY_ITALIC, ")"),
      fontStyle: 'italic'
    },
    'block-comment': {
      color: theme.commentColor,
      fontFamily: "var(".concat(VAR_CODE_FONT_FAMILY_ITALIC, ")"),
      fontStyle: 'italic'
    },
    'function-name': {
      color: theme.sectionColor
    },
    'class-name': {
      color: theme.sectionColor
    },
    doctype: {
      color: theme.docTagColor
    },
    substr: {
      color: theme.substringColor
    },
    namespace: {
      color: theme.nameColor
    },
    builtin: {
      color: theme.builtInColor
    },
    entity: {
      color: theme.literalColor
    },
    bullet: {
      color: theme.bulletColor
    },
    code: {
      color: theme.codeColor
    },
    regex: {
      color: theme.regexpColor
    },
    symbol: {
      color: theme.symbolColor
    },
    variable: {
      color: theme.variableColor
    },
    url: {
      color: theme.linkColor
    },
    'selector-attr': {
      color: theme.selectorAttributeColor
    },
    'selector-pseudo': {
      color: theme.selectorPseudoColor
    },
    type: {
      color: theme.typeColor
    },
    string: {
      color: theme.stringColor
    },
    quote: {
      color: theme.quoteColor
    },
    tag: {
      color: theme.templateTagColor
    },
    title: {
      color: theme.titleColor
    },
    section: {
      color: theme.sectionColor
    },
    'meta-keyword': {
      color: theme.metaKeywordColor
    },
    meta: {
      color: theme.metaColor
    },
    italic: {
      fontStyle: 'italic'
    },
    bold: {
      fontWeight: 'bolder'
    },
    function: {
      color: theme.functionColor
    },
    number: {
      color: theme.numberColor
    },
    'attr-value': {
      color: theme.attributeColor
    },
    prolog: {
      color: theme.prologColor
    },
    cdata: {
      color: theme.cdataColor
    },
    punctuation: {
      color: theme.punctuationColor
    },
    property: {
      color: theme.propertyColor
    },
    constant: {
      color: theme.constantColor
    },
    deleted: {
      color: theme.deletedColor
    },
    boolean: {
      color: theme.booleanColor
    },
    char: {
      color: theme.charColor
    },
    inserted: {
      color: theme.insertedColor
    },
    operator: {
      color: theme.operatorColor
    },
    atrule: {
      color: theme.atruleColor
    },
    important: {
      color: theme.importantColor,
      fontWeight: 'bold'
    }
  };
}; // NB. applied on the 'pre' tag or equivalent


var codeStyle = function codeStyle(theme) {
  var _ref;

  return _ref = {
    fontSize: theme.codeFontSize || CODE_FONT_SIZE,
    lineHeight: theme.codeLineHeight || CODE_LINE_HEIGHT
  }, _defineProperty(_ref, VAR_CODE_FONT_FAMILY, codeFontFamily()), _defineProperty(_ref, VAR_CODE_FONT_FAMILY_ITALIC, "SFMono-MediumItalic, var(".concat(VAR_CODE_FONT_FAMILY, ")")), _defineProperty(_ref, "fontFamily", "var(".concat(VAR_CODE_FONT_FAMILY, ")")), _defineProperty(_ref, "backgroundColor", theme.backgroundColor), _defineProperty(_ref, "color", theme.textColor), _defineProperty(_ref, "borderRadius", borderRadius()), _defineProperty(_ref, "display", 'flex'), _defineProperty(_ref, "overflowX", 'auto'), _defineProperty(_ref, "whiteSpace", 'pre'), _ref;
};

var codeBlockStyle = function codeBlockStyle(theme) {
  return _objectSpread({
    'pre[class*="language-"]': codeStyle(theme)
  }, sharedCodeStyle(theme));
};

var inlineCodeStyle = function inlineCodeStyle(theme) {
  return _objectSpread({
    'pre[class*="language-"]': _objectSpread(_objectSpread({}, codeStyle(theme)), {}, {
      padding: '2px 4px',
      display: 'inline',
      whiteSpace: 'pre-wrap'
    })
  }, sharedCodeStyle(theme));
};
/**
 * Allows us to inject external selectors into the component.
 * Used outside the normal <pre /> tag.
 */


var codeLayoutContainer = function codeLayoutContainer(theme) {
  return function (highlightedStartText, highlightedEndText, hasLineNumbers) {
    var _ref2;

    var lineNumberThemeStyle = lineNumberStyle(theme);
    return _ref2 = {}, _defineProperty(_ref2, VAR_CODE_LINE_NUMBER_BG_COLOR, theme.lineNumberBgColor), _defineProperty(_ref2, '& .linenumber', _objectSpread(_objectSpread({}, lineNumberThemeStyle), {}, {
      display: 'inline-block !important'
    })), _defineProperty(_ref2, '& [data-ds--code--row]', {
      display: 'block',
      paddingRight: "".concat(gridSize(), "px !important"),
      marginRight: "-".concat(gridSize(), "px")
    }), _defineProperty(_ref2, '& [data-ds--code--row--highlight]', {
      background: "".concat(theme.highlightedLineBgColor),
      '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
      },
      '&::before': {
        content: "\", ".concat(highlightedStartText, ", \"")
      },
      '&::after': {
        content: "\", ".concat(highlightedEndText, ", \"")
      }
    }), _defineProperty(_ref2, '& [data-ds--code--row--highlight] .linenumber', {
      borderLeft: "4px solid ".concat(theme.highlightedLineBorderColor),
      paddingLeft: "".concat(gridSize() / 2, "px !important"),
      position: 'relative'
    }), _defineProperty(_ref2, '& [data-ds--code--row--highlight] .linenumber::before', {
      content: '""',
      position: 'absolute',
      width: '4px',
      top: '-1px',
      left: '-4px',
      borderTop: "1px solid ".concat(theme.highlightedLineBorderColor)
    }), _defineProperty(_ref2, '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]', {
      borderTop: '1px dashed transparent'
    }), _defineProperty(_ref2, '[data-ds--code--row--highlight]:last-child', {
      borderBottom: '1px dashed transparent'
    }), _defineProperty(_ref2, '& code:first-of-type', {
      paddingRight: "0px !important",
      backgroundImage: hasLineNumbers ? "linear-gradient(to right, var(".concat(VAR_CODE_LINE_NUMBER_BG_COLOR, "), var(").concat(VAR_CODE_LINE_NUMBER_BG_COLOR, ")\n        calc(").concat(theme.lineNumberWidth, " + ").concat(2 * gridSize(), "px), transparent calc(").concat(theme.lineNumberWidth, " + ").concat(2 * gridSize(), "px), transparent)") : undefined
    }), _defineProperty(_ref2, '& code:last-of-type', {
      paddingRight: "".concat(gridSize(), "px !important"),
      flex: '1 0 auto'
    }), _ref2;
  };
};

export function applyTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var maxLines = arguments.length > 1 ? arguments[1] : undefined;

  var newTheme = _objectSpread(_objectSpread({}, defaultColors(theme)), {}, {
    lineNumberWidth: maxLines ? getLineNumWidth(maxLines) : undefined
  }, theme);

  return {
    lineNumberStyle: lineNumberStyle(newTheme),
    codeBlockStyle: codeBlockStyle(newTheme),
    inlineCodeStyle: inlineCodeStyle(newTheme),
    codeLayoutContainer: codeLayoutContainer(newTheme),
    codeContainerStyle: codeContainerStyle
  };
}